import { FCT } from '@/i18n';

import { SidePanel } from '../../../../component';
import { ActivityLogs } from './activity-logs';

interface ActivityLogsSidePanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ActivityLogsSidePanel({ isOpen, onClose }: ActivityLogsSidePanelProps) {
  return (
    <SidePanel
      isOpen={isOpen}
      onClose={onClose}
      title={FCT.ACTIVITY_LOGS.TITLE}
      titleJustification="between"
    >
      {isOpen && <ActivityLogs />}
    </SidePanel>
  );
}
